import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, CardContent, Typography } from '@mui/material';
import { PartialIcon, SegmentTooltip } from '../../../../components/core';
import { AssignmentTurnedIn, CompareArrows as CompareArrowsIcon } from '@mui/icons-material';
import { getAsLongDate, getAsStartAndEndTimeFormat } from '../../../../../../common-client2/src/services/ukgDateTime';
import { hasTransfer } from '../../../../../auxilaries';
import { getShiftCardClass } from './ListViewShiftCardWithTooltip.service';
import * as Helpers from '../BillboardListView.helpers';
import { ShiftSegmentTypeName } from '../../../../../Enums';
import './ListViewShiftCardWithTooltip.scss';

const ListViewShiftCardWithTooltip = ({
    shift,
    partialShift,
    isLargeShiftTimeText = false,
    requestType,
    isVto = false,
    isOpenShift = false,
    isSignUp = false,
    isDisplaySegmentInfos = false,
}) => {
    const { t } = useTranslation('common');
    const displaySegmentInfos = (segments) => segments?.map(x => <span className={'segment-infos'}><span className={'segment-info-time'}>{Helpers.getSegmentPeriod(x)} {x.type === ShiftSegmentTypeName.TRANSFER_SEGMENT ? <CompareArrowsIcon className="segment-info-transfer" /> : ""}</span> {t(`SegmentType.${x.type}`)}</span>);

    const shiftCardClass = getShiftCardClass(requestType);
    const isPartial = !!partialShift;
    const shiftToOffer = isPartial ? partialShift : shift;
    const firstSegmentPrimaryJob = shiftToOffer.segments?.find(x => x.type !== ShiftSegmentTypeName.BREAK_SEGMENT)?.orgJobRef.qualifier;
    const shiftTimeTextClass = isLargeShiftTimeText ? 'shiftTimeTextLarge' : 'shiftTimeText';

    return (
        <SegmentTooltip
            data={shiftToOffer}
            isVto={isVto}
            isOpenShift={isOpenShift}
            isSignUp={isSignUp}
            isPartial={isPartial}
            originalShift={shift}
            placement="auto"
        >
            <>
                <Button className='transparentButtonNoPadding'>
                    <Card className={shiftCardClass}>
                        <CardContent className='fixPadding'>
                            <div>
                                <Typography className={shiftTimeTextClass}>
                                    <div>
                                        {getAsStartAndEndTimeFormat(shiftToOffer.startDateTime, shiftToOffer.endDateTime)}
                                        {hasTransfer(shift) ? ' (X) ' : ' '}
                                        {`(${getAsLongDate(shiftToOffer.startDateTime)})`}
                                    </div>
                                    {isSignUp && <AssignmentTurnedIn className="signUpIconSize"/>}
                                </Typography>
                                <Typography className='primaryJobText'>
                                    {firstSegmentPrimaryJob}
                                </Typography>
                            </div>
                            <div className="margin-right-auto" />
                            {hasTransfer(shift) && <div className="transfer-icon-wrapper"><CompareArrowsIcon /></div>}
                            {isPartial && <PartialIcon />}
                        </CardContent>
                    </Card>
                </Button>
                <Typography >   
                    {isDisplaySegmentInfos ? displaySegmentInfos(shiftToOffer?.segments) : ""}
                </Typography>
            </>
        </SegmentTooltip>
    )
};

export default ListViewShiftCardWithTooltip;